export default "__VITE_ASSET__BM$6ZggJ__"